export { default as Img200 } from './processed/200/Ballers-S1.jpg';
export { default as Img400 } from './processed/400/Ballers-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Ballers-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Ballers-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Ballers-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      248,
      200,
      59
    ],
    "_population": 1266,
    "_hsl": [
      0.12433862433862435,
      0.9310344827586209,
      0.6019607843137255
    ]
  },
  "LightVibrant": {
    "_rgb": [
      251,
      209,
      76
    ],
    "_population": 213,
    "_hsl": [
      0.12666666666666665,
      0.9562841530054647,
      0.6411764705882352
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      28,
      14,
      7
    ],
    "_population": 24,
    "_hsl": [
      0.05555555555555555,
      0.6,
      0.06862745098039216
    ]
  },
  "Muted": {
    "_rgb": [
      168,
      153,
      112
    ],
    "_population": 896,
    "_hsl": [
      0.12202380952380952,
      0.24347826086956517,
      0.5490196078431373
    ]
  },
  "LightMuted": {
    "_rgb": [
      202,
      192,
      167
    ],
    "_population": 20,
    "_hsl": [
      0.11904761904761907,
      0.2482269503546098,
      0.7235294117647059
    ]
  },
  "DarkMuted": {
    "_rgb": [
      81,
      78,
      76
    ],
    "_population": 1050,
    "_hsl": [
      0.06666666666666694,
      0.031847133757961756,
      0.307843137254902
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Ballers-S1.js